import React from 'react';
import { LINKS } from '../lib/links';
import { RouteLink } from '../lib/router';
import { WhatsAppIcon } from './WhatsAppButton';
export function StickyCTA() {
  return <>
      {/* Mobile Sticky Bottom Bar */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-cream/95 backdrop-blur-md border-t border-pine/10 p-3" data-id="element-589" data-mp="yilyiazgg6n2">
        <div className="flex gap-2 max-w-md mx-auto" data-id="element-590" data-mp="12jfln252phew">
          <a href={LINKS.whatsapp} target="_blank" rel="noopener noreferrer" aria-label="Message Zev on WhatsApp" className="flex-1 inline-flex items-center justify-center gap-2 bg-whatsapp text-white py-3.5 px-3 rounded-sm font-medium text-sm tracking-wide active:scale-[0.98] transition-transform" data-id="element-591" data-mp="1q8go88r85yc9">
            <WhatsAppIcon className="w-4 h-4" data-id="element-592" data-mp="297mareblovyy" />
            WhatsApp Zev
          </a>
          <RouteLink to="/stay" className="flex-1 inline-flex items-center justify-center gap-2 bg-cream border border-pine/25 text-pine py-3.5 px-3 rounded-sm font-medium text-sm tracking-wide active:scale-[0.98] transition-transform" data-id="element-593" data-mp="295rmbq14elq4">
            Stay
          </RouteLink>
        </div>
      </div>

      {/* Desktop Floating Button */}
      <div className="hidden md:block fixed bottom-8 right-8 z-50" data-id="element-594" data-mp="3p35kc80q1hpl">
        <a href={LINKS.whatsapp} target="_blank" rel="noopener noreferrer" aria-label="Message Zev on WhatsApp" className="inline-flex items-center gap-2 bg-whatsapp text-white py-4 px-6 rounded-sm font-medium tracking-wide shadow-2xl hover:bg-whatsappDeep hover:scale-105 transition-all duration-300" data-id="element-595" data-mp="3kakrp9tjxann">
          <WhatsAppIcon className="w-5 h-5" data-id="element-596" data-mp="6vyak35182nu" />
          WhatsApp Zev
        </a>
      </div>
    </>;
}